// Remembers where a signed-out visitor was headed so sign-in (code or emailed link) can send
// them back. Kept in localStorage because the emailed sign-in link opens in a new tab.
const KEY = 'riq_return_to';
const MAX_AGE_MS = 30 * 60 * 1000;

// Same-origin app paths only — never an absolute/protocol-relative URL (open redirect).
export const safeReturnPath = (p) => (
  typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/\\')
  && !/^\/(login|auth)(\/|\?|$)/.test(p) ? p : null
);

export const rememberReturnTo = (p) => {
  try {
    const path = safeReturnPath(p);
    if (path) localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
    else localStorage.removeItem(KEY);
  } catch (_) { /* storage unavailable */ }
};

export const takeReturnTo = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    localStorage.removeItem(KEY);
    return saved && Date.now() - saved.at < MAX_AGE_MS ? safeReturnPath(saved.path) : null;
  } catch (_) { return null; }
};
